import React from 'react'
import styled from 'styled-components'
import { IoWarningOutline } from "react-icons/io5";

const WarningMessage = (props) => {
  return (
    <WarningContainer>
      <WarningIcon><IoWarningOutline size={24} /></WarningIcon>
      <WarningText>
        {props.message}
      </WarningText>
    </WarningContainer>
  )
}

const WarningContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 10px;
  border-radius: 4px;
  margin: 0.5rem 0;
  font-family: 'Montserrat', sans-serif;
  width: fit-content;
`;

const WarningIcon = styled.div`
  margin-right: 10px;
`;

const WarningText = styled.div`
  font-size: 14px;
`;

export default WarningMessage